import { Box, Typography } from "@mui/material";
import { HidroLayer, HidroLayerGroup, HidroMap } from "../mapa";
import { useBarragemContext } from "../../context";
import { useEffect } from "react";

export const Acessos: React.FC = () => {
  const { barragem } = useBarragemContext();

  const layers = new HidroLayerGroup({
    name: "Layers",
    showing: true,
    layers: [],
  });

  useEffect(() => {
    if (!barragem || "error" in barragem) return;

    const zas = barragem.zas;
    if (!zas || "error" in zas) return;

    if (!zas.rotasAlternativas || "error" in zas.rotasAlternativas) return;
    if (!zas.pontosEncontro || "error" in zas.pontosEncontro) return;
    if (!zas.polygon || "error" in zas.polygon) return;
    if (!zas.polygonZss || "error" in zas.polygonZss) return;

    layers.flat(zas.rotasAlternativas.map(val => new HidroLayer({
      name: val.properties.nome,
      showing: true,
      layer: val,
    })));

    layers.flat(zas.pontosEncontro.map(val => new HidroLayer({
      name: val.properties.ponto,
      showing: true,
      layer: val,
    })));

    layers.push(new HidroLayer({
      name: "ZAS",
      showing: true,
      layer: zas.polygon,
    }));

    layers.push(new HidroLayer({
      name: "ZSS",
      showing: true,
      layer: zas.polygonZss,
    }));

    setTimeout(() => layers.centerBounds(), 500);

  }, [barragem]);


  return <Box sx={{
    flex: 1,
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  }}>
    {/* Nome */}
    <Typography fontSize={26} fontWeight={600}>
      Rotas Alternativas
    </Typography>

    <HidroMap
      recenter
      expandable
      screenshot
      startWithTile
      hidroLayers={layers}
    />
  </Box>;
};